module.exports = __webpack_public_path__ + "img/responses.3bd73c6d.svg";